import axios from "axios";

export const getReferences = async () => {
  const res = await axios.get("https://alnabaatech.com.ly/api/references");
  return res.data.data;
};